import PropTypes from 'prop-types';
import EventListSkeletonImpl from './event-list-skeleton.js';
import MojitoCore from 'mojito/core';

const { UIView } = MojitoCore.Presentation;

/**
 * Event list skeleton component used to represent loading event list.
 *
 * @function EventListSkeleton
 * @memberof Mojito.Modules.EventList
 */

/**
 * EventListSkeleton prop types.
 *
 * @property {string} [sportId] - Sport id. Used to determine if US style skeletons will be displayed.
 * @property {boolean} [enableSorting] - Enable sorting mode style.
 * @property {boolean} [isInPlay] - Flag indicating if it is In Play type.
 * @property {object | Function} [elementRef] - A ref to the rendered element.
 * @property {object} [eventListConfig] - EventList config.
 * @property {boolean} [isOutrights = false] - Flag used to determine whether component is rendered within outrights.
 *
 * @memberof Mojito.Modules.EventList.EventListSkeleton
 */
const propTypes = {
    sportId: PropTypes.string,
    enableSorting: PropTypes.bool,
    isInPlay: PropTypes.bool,
    elementRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    eventListConfig: PropTypes.object,
    isOutrights: PropTypes.bool,
};

const defaultProps = {
    isOutrights: false,
};

export default UIView('EventListSkeleton', EventListSkeletonImpl, propTypes, defaultProps);
